module.exports = __webpack_public_path__ + "static/img/level-card-banner2.95153f4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/7/level-card-banner2.png
// module id = uACt
// module chunks = 1